<script>
  import reveal from '../lib/actions/reveal.js';
  import tilt from '../lib/actions/tilt.js';
  import SectionHeader from '../lib/ui/SectionHeader.svelte';
  import GlowCard from '../lib/ui/GlowCard.svelte';
</script>

<section id="what" class="section" aria-label="What is Lumina">
  <div class="container">
    <div use:reveal>
      <SectionHeader big glow>
        <span slot="title">
          <span class="title-line">What is Lumina</span>
          <span class="title-line text-gradient nowrap">Launchpad for NFAs</span>
        </span>
        <span slot="desc">Once, NFTs were static, art without life. Lumina gives them Light, a pulse of AI energy that awakens their mind.</span>
      </SectionHeader>
    </div>

    <div use:reveal style="margin-top: 16px;">
      <GlowCard padding="0">
        <div style="position:relative; overflow:hidden; border-radius: var(--r-m); aspect-ratio: 16/9; background:#000;">
          <img src="/media/nfascence.png" alt="NFAs awakening — static poster" style="position:absolute; inset:0; width:100%; height:100%; object-fit:cover; display:block;" />
          <div class="beams" aria-hidden="true" style="opacity:.25">
            <div class="beam" style="left:12%"></div>
            <div class="beam" style="left:55%"></div>
          </div>
        </div>
      </GlowCard>
    </div>

    <style>
      .title-line { display: block; }
      .nowrap { white-space: nowrap; }
      @media (max-width: 900px) { .nowrap { white-space: normal; } }
    </style>
  </div>
</section>
